module.exports = __webpack_public_path__ + "static/media/lovefield.2baa38f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/lovefield.png
// module id = 141
// module chunks = 0